import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
export const dateTimeDisplay = (date?: string | null) => {
  if (date && dayjs(date).isValid()) {
    return dayjs(date).utc().local().format("L");
  }
  return "";
};

export const utcToLocal = (date?: string) => {
  if (date && dayjs(date).isValid()) {
    return dayjs(date).utc().local();
  }
  return null;
};

export const dateTimeToUTCString = (date?: string | Dayjs | null) => {
  if (date && dayjs(date).isValid()) {
    return dayjs(date)
      .set("hour", 0)
      .set("minute", 0)
      .set("second", 0)
      .set("millisecond", 0)
      .utc()
      .format();
  }
  return "";
};
